import ecoSystem from 'constants/ecoSystem'
import siteCoverage from 'constants/siteCoverage'
import oecmOverlap from 'constants/oecmOverlap'
import formatNum2Dp from 'utils/formatNum2DP'
import formatNum4Dp from 'utils/formatNum4DP'

const getOptionByValue = (options, value) => {
  return options.find((option) => option.value === value) || null
}

const getFormattedNumericValue = (value, formatter) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  return formatter(value)
}

export const buildDetailsInitialState = (siteData = {}) => {
  const sensitiveSite = Object.prototype.hasOwnProperty.call(siteData, 'sensitive_site')
    ? Boolean(siteData.sensitive_site)
    : Boolean(siteData.sensitiveSite)
  const sensitiveSiteDetails = Object.prototype.hasOwnProperty.call(siteData, 'sensitive_site_details')
    ? (siteData.sensitive_site_details || '')
    : (siteData.sensitiveSiteDetails || '')

  return {
    initialEcoSystemId: getOptionByValue(ecoSystem, siteData.EcoSystemsId),
    initialEcoSystems2LargestId: getOptionByValue(ecoSystem, siteData.EcoSystems2LargestId),
    initialEcoSystems3LargestId: getOptionByValue(ecoSystem, siteData.EcoSystems3LargestId),
    initialEcoSystemsSmallestId: getOptionByValue(ecoSystem, siteData.EcoSystemsSmallestId),
    initialCoverageOfProtectedAreasId: getOptionByValue(siteCoverage, siteData.CoverageOfProtectedAreasId),
    initialOECMOverlap: getOptionByValue(oecmOverlap, siteData.overlapOECMProtectedCoverage),
    name: siteData.name || '',
    siteNameNational: siteData.siteNameNational || '',
    countryCode: siteData.SiteDetailsCountryId,
    state: siteData.state || '',
    siteArea: getFormattedNumericValue(siteData.siteArea, formatNum2Dp),
    latitudeOfMidPoint: getFormattedNumericValue(siteData.latitudeOfMidPoint, formatNum4Dp),
    longitudeOfMidPoint: getFormattedNumericValue(siteData.longitudeOfMidPoint, formatNum4Dp),
    highestAltitude: getFormattedNumericValue(siteData.highestAltitude, formatNum2Dp),
    lowestAltitude: getFormattedNumericValue(siteData.lowestAltitude, formatNum2Dp),
    minimumDepth: getFormattedNumericValue(siteData.minDepth, formatNum2Dp),
    maximumDepth: getFormattedNumericValue(siteData.maxDepth, formatNum2Dp),
    rationaleForSiteInformation: siteData.rationaleForSiteInformation || '',
    siteDescription: siteData.siteDescription || '',
    sensitiveSite,
    sensitiveSiteDetails,
    howIsTheSiteManaged: siteData.howIsTheSiteManaged || '',
    deliniationRationale: siteData.deliniationRationale || '',
    coveredByWhatProtectedAreas: siteData.coveredByWhatProtectedAreas || '',
    additionalBiodiversityValues: siteData.additionalBiodiversityValues || '',
    landUseRegimesAtSite: siteData.landUseRegimesAtSite || '',
    coveredByPa: getFormattedNumericValue(siteData.calculatedProtectedArea, formatNum2Dp),
    coveredByOECM: getFormattedNumericValue(siteData.calculatedOECMArea, formatNum2Dp),
    threatsDescription: siteData.threatsDescription || '',
    supersidedSites: siteData.supersededSitesDesription || '',
    notes: siteData.notes || '',
    habitat: siteData.habitatDescription || '',
    indigenousGroups: siteData.indigenousGroups || '',
    references: siteData.references || '',
    contributors: siteData.consultationWithContributors || ''
  }
}
